import React, {useEffect, useState} from 'react';
import styled from "styled-components"
import TBSelect from "../Commons/TBSelect.react";
import ReportGraph from "../Commons/Graphs/ReportGraph.react";
import Badge from "../Commons/Badge.react";

const StyledReportNew = styled.div`
  .date-selection {
    display: flex;
    align-items: center;
    width: 80rem;
  }
  
  .comparison-label {
    padding-left: 2rem;
    padding-right: 2rem;
    color: #636363;
    p {
      font-size: 2rem;
    }
  }
  
  .reports-container {
    padding-top: 2rem;
    display: flex;
    justify-content: space-between;
    
    .report {
      border: none;
      box-shadow: 0px 3px 15px rgba(0,0,0,0.2);
      width: 100%;
      height: 32rem;
      padding: 1.5rem;
      margin: 1rem;
      
      .title {
        display: flex;
        justify-content: left;
        font-size: 2.2rem;
        color: black;
      }
      
      .fiat-total {
        font-size: 2.5rem;
        color: #4F4F4F;
      }
    }
  }
`

const FILTERS = {
  FLAGS: ['Manually Edited', 'Missing Price', 'Possibly Incorrect Price'],
  RANGE: ['July 13-19', 'Custom'],
  DATE: ['This Week','2014', '2015', '2016', '2017', '2018', '2019', '2020', '2021', 'This Month', 'Last Month', 'Custom Range'],
  PERIOD: ['Newest', 'Oldest']
}



const ReportsNew = () => {
  const handleSelect = () => {
    alert('hi')
  }
  return (
    <StyledReportNew>
      <h5>Reports</h5>
      <div className={'date-selection'}>
        <div>
          <div><TBSelect clear label={'This Week'} listItems={FILTERS.DATE} handleSelect={handleSelect} /></div>
        </div>
        <div>
          <div><TBSelect clear label={"July 13 - July 19"} listItems={FILTERS.RANGE} handleSelect={handleSelect} /></div>
        </div>
        <div className={'comparison-label'}>
          <p>compared to</p>
        </div>
        <div>
          <div><TBSelect clear label={'Previous Period'} listItems={FILTERS.PERIOD} handleSelect={handleSelect} /></div>
        </div>
      </div>
      <div className={'reports-container'}>
        <div className={'report'}>
          <div className={'title'}>Total Holdings (USD) <Badge type={'number'} stat={-15.3} /></div>
          <div className={'fiat-total'}>$12.34m</div>
          <ReportGraph data={fakeDataOne} />
        </div>
        <div className={'report'}>
          <div className={'title'}>Revenue Per Customer <Badge type={'number'}  stat={23.8} /></div>
          <div className={'fiat-total'}>$78</div>
          <ReportGraph data={fakeDataTwo} />
        </div>
        <div className={'report'}>
          <div className={'title'}>New Customers <Badge type={'number'} stat={9.6} /></div>
          <div className={'fiat-total'}>1,342</div>
          <ReportGraph data={fakeDataThree} />
        </div>
      </div>
    </StyledReportNew>
  )
}

export default ReportsNew;


export const fakeDataOne = [
  {
    "date": "July 13",
    "This Week": 1900,
    "Last Week": 2200,
    "amt": 2400
  },
  {
    "date": "July 14",
    "This Week": 2100,
    "Last Week": 1890,
    "amt": 2210
  },
  {
    "date": "July 15",
    "This Week": 2300,
    "Last Week": 1900,
    "amt": 2290
  },
  {
    "date": "July 16",
    "This Week": 2800,
    "Last Week": 2090,
    "amt": 2000
  },
  {
    "date": "July 17",
    "This Week": 2300,
    "Last Week": 2600,
    "amt": 2181
  },
  {
    "date": "July 18",
    "This Week": 2700,
    "Last Week": 2399,
    "amt": 2500
  },
  {
    "date": "Today",
    "This Week": 2400,
    "Last Week": 2900,
    "amt": 2100
  }
]

export const fakeDataTwo = [
  {
    "date": "July 13",
    "This Week": 3000,
    "Last Week": 900,
    "amt": 2400
  },
  {
    "date": "July 14",
    "This Week": 3750,
    "Last Week": 1400,
    "amt": 2210
  },
  {
    "date": "July 15",
    "This Week": 3000,
    "Last Week": 1250,
    "amt": 2290
  },
  {
    "date": "July 16",
    "This Week": 3250,
    "Last Week": 1300,
    "amt": 2000
  },
  {
    "date": "July 17",
    "This Week": 3650,
    "Last Week": 1620,
    "amt": 2181
  },
  {
    "date": "July 18",
    "This Week": 4750,
    "Last Week": 1850,
    "amt": 2500
  },
  {
    "date": "Today",
    "This Week": 5800,
    "Last Week": 2150,
    "amt": 2100
  }
]

export const fakeDataThree = [
  {
    "date": "July 13",
    "This Week": 2900,
    "Last Week": 2200,
    "amt": 2400
  },
  {
    "date": "July 14",
    "This Week": 9100,
    "Last Week": 1890,
    "amt": 2210
  },
  {
    "date": "July 15",
    "This Week": 8300,
    "Last Week": 1900,
    "amt": 2290
  },
  {
    "date": "July 16",
    "This Week": 2800,
    "Last Week": 2200,
    "amt": 2000
  },
  {
    "date": "July 17",
    "This Week": 2300,
    "Last Week": 9100,
    "amt": 2181
  },
  {
    "date": "July 18",
    "This Week": 5400,
    "Last Week": 7399,
    "amt": 2500
  },
  {
    "date": "Today",
    "This Week": 7400,
    "Last Week": 2900,
    "amt": 2100
  }
]